import type { Database } from "@excel-center/supabase";
import { z } from "zod";

type DBStudentTierLevel = Database["public"]["Enums"]["student_tier_level"];

export const StudentTierLevel = {
	TIER_1: "tier_1",
	TIER_2: "tier_2",
	TIER_3: "tier_3",
} as const satisfies Record<string, DBStudentTierLevel>;

export type StudentTierLevel = (typeof StudentTierLevel)[keyof typeof StudentTierLevel];

type _EnsureAllDBValues = Exclude<DBStudentTierLevel, StudentTierLevel> extends never ? true : never;
const _check: _EnsureAllDBValues = true;
void _check;

export const STUDENT_TIER_LEVELS = Object.values(StudentTierLevel) as readonly StudentTierLevel[];

export const studentTierLevelSchema = z.enum(StudentTierLevel);

export const STUDENT_TIER_LEVEL_LABELS: Record<StudentTierLevel, string> = {
	tier_1: "Tier 1 - Recognized",
	tier_2: "Tier 2 - Valued",
	tier_3: "Tier 3 - Preferred",
};
